// extracted by mini-css-extract-plugin
module.exports = {"header":"_a1d0b58","fixedHeader":"_2c642c5","section":"_a853912","sectionEmbeddedAccount":"_472b86f"};